module.exports = __webpack_public_path__ + "img/quiz.5ea3702b.svg";